import { createStore } from 'vuex'
import cookies from 'vue-cookies'
import router from "@/router";

// درون ریزی ماژول‌ها
import jobDescription from "@/store/modules/OrganizationId/jobDescription";
import jobQualification from "@/store/modules/OrganizationId/jobQualification";
import jobProfessionalValues from "@/store/modules/OrganizationId/jobProfessionalValues";
import jobResponsibilities from "@/store/modules/OrganizationId/jobResponsibilities";
import communicationDomain from "@/store/modules/OrganizationId/communicationDomain";
import dutiesDescription from "@/store/modules/OrganizationId/dutiesDescription";
import competencies from "./modules/OrganizationId/competenciesKnowledge";
import abilities from "./modules/OrganizationId/competenciesAbility";
import skills from "./modules/OrganizationId/competenciesSkill";
import courses from "./modules/OrganizationId/competencyCourses";
import rules from "./modules/OrganizationId/rules";
import powers from "./modules/OrganizationId/powers";
import responsibilityHierarchy from "./modules/OrganizationId/responsibilityHierarchy";
import jobProtectionClassification from "./modules/OrganizationId/jobProtectionClassification";
import suppliers from "./modules/OrganizationId/suppliers";
import crudActions from "./modules/OrganizationId/crudActions";
import generalModules from './modules/generalModules';
import jobDescriptionModules from './modules/jobDescriptionModules';
import strategicPlanningModules from './modules/strategicPlanningModules';
import riskCharter from './modules/riskManagementModules/riskCharter';
import riskPolicy from './modules/riskManagementModules/riskPolicy';
import riskStatement from './modules/riskManagementModules/riskStatement';

export default createStore({
  state: {
    isAuth: false,
    statusInformation: false,
    is_show: true, // وضعیت کلی نمایش مسیرها
    executive_element: false, // وضعیت کلی نمایش مسیرها
    menu: false, // منوی کاربری
    mother_mode: false,
    is_mother: 0,
    image_profile:false,
    is_process_manager: 0,
    id_login: '',
    session_end_time: '', // اضافه کردن image_profile به state اگر در mutation login استفاده می‌کنید
  },
  getters: {
    // می‌توانید getters ایجاد کنید اگر نیاز به دسترسی خاص به state دارید
  },
  mutations: {
    // mutation جدید برای ست کردن وضعیت احراز هویت به صورت سینک
    setAuthStatus(state, payload) {
     
      state.isAuth = payload.isAuth;
      state.mother_mode = payload.mother_mode;
      state.is_mother = payload.is_mother;
      state.is_process_manager = payload.is_process_manager;
      state.id_login = payload.id_login;
      state.session_end_time= payload.session_end_time;
      state.image_profile= payload.image_profile;
    },

    login(state, res) {
      if (res.id) {
        state.isAuth = true;
        state.mother_mode = res.mother_mode;
        state.is_mother = res.is_mother;
        state.is_process_manager = res.is_process_manager;
        state.id_login = res.id;
        state.session_end_time = res.session_end_time;
        state.image_profile = res.image_profile;
        router.push('/pishkhan');
      } else {
        state.isAuth = false;
        state.mother_mode = false;
        state.is_mother = 0;
        state.is_process_manager = false;
        state.id_login = '';
        state.session_end_time = '';
        state.image_profile = false;
      }
    },

     set_time(state, time) {
      if (time) {
        state.session_end_time = time;
      }
    },
    
    logout(state,type) {
      state.isAuth = false;
      state.mother_mode = false;
      state.is_mother = 0;
      state.is_process_manager = false;
      state.id_login = '';
      state.session_end_time = '';
      state.image_profile = false;

      const allCookies = cookies.get();
      if (allCookies) {
        Object.keys(allCookies).forEach(cookieName => {
          cookies.remove(cookieName);
        });
      }
      localStorage.clear();
      sessionStorage.clear();
      if(type=="user"){
        router.push('/');
      }
    },

    setSharedList(state, newList) {
      state.statusInformation = newList;
      setTimeout(() => {
        if (state.statusInformation) {
          state.statusInformation = false;
        }
      }, 1000);
    },

    setIsShow(state, value) {
      state.is_show = value;
    },

    setExecutiveElement(state, value) {
      state.executive_element = value;
    },

    setMenu(state, menuData) {
      state.menu = menuData;
    }
  },

  actions: {
    // اکشن جدید برای بررسی لاگین کاربر (جایگزین onstart)
    async checkLoginStatus({ commit }) {

      
      try {
        const requestOptions = {
          method: 'GET',
          credentials: 'include',
          headers: {
          
          'Accept': 'application/json',
        },
          
        };

        const response = await fetch('https://apibehfam-nigc.ara-softco.ir/api/auth/check-login', requestOptions);
        const data = await response.json();
 
        if (data.id) {
          commit('setAuthStatus', {
            isAuth: true,
            mother_mode: data.mother_mode,
            is_mother: data.is_mother,
            is_process_manager: data.is_process_manager,
            id_login: data.id,
            session_end_time: data.session_end_time,
            image_profile: data.image_profile
          });
        } else {
          commit('setAuthStatus', {
            isAuth: false,
            mother_mode: false,
            is_mother: 0,
            is_process_manager: false,
            id_login: '',
            session_end_time: '',
            image_profile : false
          });
        }
      } catch (error) {
        console.error("Error checking login status:", error);
        // در صورت بروز خطا، وضعیت را به عنوان لاگ‌اوت در نظر بگیرید
        commit('setAuthStatus', {
          isAuth: false,
          mother_mode: false,
          is_mother: 0,
          is_process_manager: false,
          id_login: '',
          session_end_time: '',
          image_profile : false
        });
      }
    },

    updateIsShow({ commit }, value) {
      commit('setIsShow', value);
    },

    updateMenu({ commit }, menuData) {
      commit('setMenu', menuData);
    }
  },

  modules: {
    jobDescription,
    jobQualification,
    jobProfessionalValues,
    jobResponsibilities,
    communicationDomain,
    dutiesDescription,
    competencies,
    abilities,
    skills,
    courses,
    rules,
    powers,
    responsibilityHierarchy,
    jobProtectionClassification,
    suppliers,
    crudActions,
    ...generalModules,
    ...jobDescriptionModules,
    ...strategicPlanningModules,
    riskCharter,
    riskPolicy,
    riskStatement,
  }
});